import { useContext } from 'react';
import AppBarContext from '../../../components/BusinessPortalAppBarContext';

interface KpiLinkProps {
  navigationTarget: string;
}
const ValueInputDashboardLink = ({ navigationTarget }: KpiLinkProps) => {
  const { setValueInputNavigationTarget } = useContext(AppBarContext);

  setValueInputNavigationTarget(navigationTarget);
  return null;
};

export default ValueInputDashboardLink;
